import { gql, useQuery } from "@apollo/client";

const CAMPAIGNREPORT_QUERY = gql`
  query CampaignReport(
    $startDate: DateTime!
    $endDate: DateTime!
    $filters: ReportFilterArgs
  ) {
    CampaignReport(
      startDate: $startDate
      endDate: $endDate
      filters: $filters
    ) {
      campaignId
      websiteId
      campaign {
        _id
        name
      }
      website {
        _id
        name
        publisher {
          name
          _id
        }
      }
      payout
      reads
    }
  }
`;

type CampaignReport = {
  CampaignReport: {
    campaignId: string;
    campaign: {
      _id: string;
      name: string;
    };
    websiteId: string;
    website: {
      _id: string;
      name: string;
      publisher: {
        name: string;
        _id: string;
      };
    };
    payout: number;
    reads: number;
  }[];
};

export function useCampaignReport(variables: any) {
  const { loading, error, data } = useQuery<CampaignReport>(
    CAMPAIGNREPORT_QUERY,
    { variables }
  );

  return { loading, error, data };
}
